import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import NonBilledSessionsReportList, { DispatchProps, OwnProps, StateProps } from './NonBilledSessionsReportList';
import { StoreState } from 'src/store/reducers';
import {
    getNonBilledSessionsReport,
    getNonBilledSessionsReportCsv,
} from 'src/store/actions/nonBilledSessionsReport-actions';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { selectNameStudents } from 'src/store/selectors/students-selectors';
import { selectNameSerTypesDropDown } from 'src/store/selectors/service-types-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.nonBilledSessionsReport.data,
        inProgress: state.nonBilledSessionsReport.inProgress,
        students: selectNameStudents(state),
        serviceTypes: selectNameSerTypesDropDown(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: any) => dispatch(getNonBilledSessionsReport(params)),
        getDataCsv: (params: any) => dispatch(getNonBilledSessionsReportCsv(params)),
        getStudents: (params: any) => dispatch(getStudentsSmall(params)),
        getServiceTypes: (params: any) => dispatch(getServiceTypes(params)),
    };
}

const NonBilledSessionsReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(NonBilledSessionsReportList);

export default NonBilledSessionsReportListScreen;
